import { useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import { useWide } from "../../lib/useWide";

// On phones, long blocks start folded behind one tap. From the md breakpoint up the children render as normal.
export const MobileFold = ({ id, title, teaser, cta = "Show", dark = false, children }) => {
  const wide = useWide("(min-width: 768px)");
  const [open, setOpen] = useState(false);
  const bodyRef = useRef(null);
  if (wide) return children;

  const tone = dark
    ? "bg-[#FBF7F1]/10 border-white/15 text-white hover:bg-[#FBF7F1]/15"
    : "bg-white border-stone-200 text-[#2E2A26] hover:border-[#C85A38]/50";

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={`w-full text-left rounded-2xl border p-5 flex items-center gap-4 transition-colors ${tone}`}
        aria-expanded="false"
        aria-controls={`fold-${id}`}
        data-testid={`fold-${id}-open`}
      >
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium">{title}</p>
          {teaser && <p className={`text-xs mt-1 leading-relaxed ${dark ? "text-white/60" : "text-[#2E2A26]/55"}`}>{teaser}</p>}
        </div>
        <span className={`flex-shrink-0 inline-flex items-center gap-1.5 text-xs font-medium rounded-full px-3 py-2 ${dark ? "bg-[#C89B7B] text-[#2E2A26]" : "bg-[#C85A38] text-white"}`}>
          {cta} <ChevronDown className="w-3.5 h-3.5" />
        </span>
      </button>
    );
  }

  return (
    <div id={`fold-${id}`} ref={bodyRef} className="animate-in fade-in slide-in-from-top-2 duration-300" data-testid={`fold-${id}-body`}>
      {children}
      <button
        type="button"
        onClick={() => {
          const section = bodyRef.current?.closest("section");
          setOpen(false);
          if (section && section.getBoundingClientRect().top < 0) section.scrollIntoView({ behavior: "auto", block: "start" });
        }}
        className={`mt-4 mx-auto flex items-center gap-1.5 text-xs font-medium min-h-[44px] px-4 ${dark ? "text-[#C89B7B]" : "text-[#C85A38]"}`}
        data-testid={`fold-${id}-close`}
      >
        Show less <ChevronDown className="w-3.5 h-3.5 rotate-180" />
      </button>
    </div>
  );
};
